module.exports = __webpack_public_path__ + "static/media/WNCWlocalcolorlogo2005.41af4f8c.webp";